// extracted by mini-css-extract-plugin
module.exports = {"rgtk-page-container":"container_rgtk-page-container__YseMa"};